(function(){
    angular
        .module('appback')
        .directive('ngCaptureenter', captureenter);

        captureenter.$inject = ['ResultadosService','$timeout'];
        function captureenter(ResultadosService,$timeout){
            return {
	            //require: 'ngModel',
	            //templateUrl: '/backend/web/app/analiticas/captureenter.html',
		        /*scope: {
                  //ngModel : '=',
                  item: '=',
                  animal: '=',
                  sub: '='
              	},*/
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {

						$(document).on('select2:select','.select2', function(e) {
						//console.log(e.keyCode);
						if(e.keyCode === 13) {

						}
						});
			        });
		        }
          }
      }
})();